export default "__VITE_ASSET__CGVWY_HS__"